export default __webpack_public_path__ + "static/media/arrows.e8e43f84.svg";